<template>
  <ResponsiveModal
    v-model:open="open"
    @update:open="handleUpdateOpen"
    variant="create"
    :title="$t('components.task_details.checklist.create.title')"
    :description="$t('components.task_details.checklist.create.description')"
    :confirmLabel="
      $t('components.buttons.save') +
      ' (' +
      ((itemsCount || 0) + items.length) +
      ')'
    "
    :withClose="false"
    :disableConfirm="busy || !(isDirty || !isEmpty(items))"
    alignButtons="center"
    @confirm="$emit('add:items', items)"
  >
    <slot>
      <VisuallyHidden>
        <Button ref="triggerRef" />
      </VisuallyHidden>
    </slot>
    <template #content>
      <div class="flex flex-col items-center p-4">
        <span v-if="maxSmall">
          {{ $t("components.task_details.checklist.create.description") }}
        </span>
      </div>
      <div class="flex flex-col grow border-t overflow-y-auto">
        <div class="flex flex-col grow py-4 px-5 md:px-3 bg-secondary">
          <!-- only render when open, so that autofocus works -->
          <GroupsInput
            v-if="open"
            as="textarea"
            variant="checklist_item"
            v-model="items"
            v-model:isDirty="isDirty"
            :placeholder="
              $t(
                'components.task_details.checklist.create.form.items.placeholder'
              )
            "
          />
        </div>
      </div>
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { ref } from "vue";
import { isEmpty } from "lodash";
import { VisuallyHidden } from "radix-vue";
import { Button } from "@/SharedComponents/Buttons";
import { GroupsInput } from "@/SharedComponents/Inputs";
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["add:items"]);

defineProps({
  busy: { type: Boolean, default: false },
  itemsCount: { type: Number, required: true },
});

const open = ref(undefined);
const items = ref([]);
const isDirty = ref(false);

function handleUpdateOpen(open) {
  if (!open) {
    items.value = [];
    isDirty.value = false;
  }
}

const triggerRef = ref(null);

function openModal() {
  triggerRef.value?.$el.click();
}

defineExpose({
  openModal,
});
</script>
